import React, { useMemo, useState, useCallback, useEffect } from 'react'
import {
  Box,
  Text,
  IcoMoon,
  Loader,
  ArrowDownIcon,
  QuestionIcon,
  DownloadInvoiceButton,
  TrackOrderButton,
} from '@usap/uicomponents'
import { outsideClickHandler } from '@usap/core'
import InvoiceWmo from '../InvoiceWmo'
import OrdersWMO from './OrdersWMO'
import commaSeparetedValue from '../../../helpers/commaSeparetedValue'
import CovidMessage from '../../common/CovidMessage'
import ReturnDetails from './ReturnDetails/ReturnDetails'
import TempBreadcrumbWMO from './ReturnDetails/TempBreadcrumbWMO'
import { getButtonType, setUrlReturnTypeParam } from '../OrderHistory/components/buttons/manageButtonType'
import useGetLifetimeReplacementFlag from '../RMA/hooks/useGetLifetimeReplacementFlag'
import MyAccountOrderDetailsSkeletonWMO from '../../Skeletons/MyAccountOrderDetailsWMO.skeleton'
import { isMembershipSku } from '../../../helpers'
import useViewPort from '../../../../../carparts/src/hooks/useViewPort';
import { CarpartsCreditCardOrderDetailsBadge } from '../../../../../carparts/src/shared/components/CarpartsCreditCard/CarpartsCreditCardOrderDetailsBadge'

import {
  Container,
  Border,
  OrderInformationBox,
  InformationBox,
  InformationTitleBox,
  OrdersContainer,
  ToolTip,
  ToolTipContent,
  ToolTipArrow,
  SubTotalTipIcon,
  ToolTipContainer,
  OrderSummaryContainer,
  OrderDetailsContainer,
  MainContainer,
  Divider,
  OrderSummaryRow,
  OrderDetailsDivider,
  BackgroundColorWrapper,
  OrderDetailRecomWrapper,
  UptickWrapper,
} from './OrderDetailsWMO.css'
import {
  LiveChat,
} from './OrderWMO.css'
import { Heading2 } from '../../common/heading'
import EnablePushNotificationModal from '@usap/carparts/src/shared/components/common/EnablePushNotificationModal'
import { useSparkChatEnabled } from '@usap/carparts/src/shared/hooks'

export default function OrderDetails({
  isDesktop,
  config,
  orderDetails,
  orderInvoice,
  handlePrintInvoice,
  invoiceLoading,
  returnReasonUtils,
  isLoading,
  Link,
  creditStatus,
  returnRequestStatus,
  isPrintLoading,
  navigateToRMA,
  covidCookie,
  formatBrand,
  OpenChatHandler,
  coreConfig,
  isCustomerTrackOrderRoute,
  history,
  GTM,
  productProtectionPlan,
  isEppSubtext,
  pushNotificationData,
  recommendationsComponent,
  unfoldedShippingConfig,
}) {
  const currentUrl = typeof window === 'object' && window.location.href.split('/')
  const isTrackOrder = currentUrl && currentUrl[currentUrl.length - 1].includes('trackorder')
  const isLifetimeReplacement = useGetLifetimeReplacementFlag()
  const returnType = isLifetimeReplacement ? getButtonType() : ''
  const returnTypeParam = setUrlReturnTypeParam(returnType)
  const urlReturnTypeParam = returnTypeParam ? `?${returnTypeParam}` : ''
  const { isMobile } = useViewPort();
  const { orderDetailsLoaded = {}  } = GTM || {}
  const isSparkChatEnabled = useSparkChatEnabled();

  const links = useMemo(() => [
    { text: 'My Account', value: '/myaccount' },
    {
      text: isTrackOrder
        ? 'Track Order'
        : 'Order History',
      value: isTrackOrder
        ? '/myaccount/trackorder'
        : `/myaccount/orderhistory${urlReturnTypeParam}`,
    },
    { text: 'Order Details', value: '' },
  ], [isTrackOrder, urlReturnTypeParam])

  useEffect(() => {
    if(orderDetails && orderDetails.items && orderDetails.items.length > 0) {
      orderDetailsLoaded()
    }
  }, [
    orderDetails
  ])

  const shipping = orderDetails && orderDetails.shipping
  const shipAddress = (shipping && shipping.address) || {}
  const billing = (orderDetails && orderDetails.billing) || {}
  const orderSummary = (orderDetails && orderDetails.orderSummary) || {}
  const items = (orderDetails && orderDetails.items) || []
  const [displayReturnDetails, setDisplayReturnDetails] = useState(false)
  const [returnDetailsData, setReturnDetailsData] = useState({})
  // eslint-disable-next-line no-undef
  const showMessage = __BROWSER__ && window.getCookieRegex(covidCookie) === '1'
  const [showToolTip, setShowToolTip] = useState(false)
  const onInvoicePrint = useCallback(() => {
    handlePrintInvoice()
  }, [handlePrintInvoice])

  const onToolTip = useCallback(e => {
    e.stopPropagation()
    outsideClickHandler(
      showToolTip,
      ['subtotaltooltipicon'],
      () => {
        setShowToolTip(false)
      },
    )
    setShowToolTip(!showToolTip)
  }, [showToolTip])

  const beautifyTelephoneNumber = (num) => {
    if (num.length == 10)
      return `(${num.slice(0, 3)})` + ' ' + num.slice(3, 6) + '-' + num.slice(6);
    return num;
  }

  const handleTrackPackageBtnClick = () => {
    if (orderDetails?.trackPackageUrl) {
      const referer = `/myaccount/orderdetails?orderId=${orderDetails?.orderId}`
      window.location.href = orderDetails.trackPackageUrl + `&referer=${encodeURIComponent(referer)}`
    }
  }

  const isESPP = Boolean(orderDetails?.shippingProtection && orderDetails?.shippingProtection !== '')
  const eSPPAmount = orderDetails?.shippingProtection?.amount > 0 ? orderDetails?.shippingProtection?.amount : 0.00
  const isMembershipOrder = Array.isArray(orderDetails?.items) && orderDetails.items.length == 1 && isMembershipSku(orderDetails.items[0].partNumber);

  if (isLoading) {
    return (
      <>
        <MyAccountOrderDetailsSkeletonWMO />
        <Loader />
      </>
    )
  }

  if (!orderDetails || !Object.keys(orderDetails).length) return ''

  if (displayReturnDetails) {
    return (
      <ReturnDetails
        Link={Link}
        isDesktop={isDesktop}
        creditStatus={creditStatus}
        returnReasonUtils={returnReasonUtils}
        returnDetailsData={returnDetailsData}
        returnRequestStatus={returnRequestStatus}
        setReturnDetailsData={setReturnDetailsData}
        setDisplayReturnDetails={setDisplayReturnDetails}
        OpenChatHandler={OpenChatHandler}
        isCustomerTrackOrderRoute={isCustomerTrackOrderRoute}
      />
    )
  }
  return (
    <div style={{ background: "#fff" }}>
      <BackgroundColorWrapper>
        <MainContainer>
          {!isCustomerTrackOrderRoute && <TempBreadcrumbWMO links={links} Link={Link} />}
          {isPrintLoading && <Loader />}
          {orderInvoice && <InvoiceWmo orderDetails={orderInvoice} pageType="orderDetails" unfoldedShippingConfig={unfoldedShippingConfig} />}
          <Heading2
            title='Order Details'
            style={{
              fontWeight: '500'
            }}
          />
          <Container>
            <OrderDetailsContainer>
              {showMessage && <CovidMessage borderColor="#4A90E2" />}
              <div style={{ marginBottom: '16px' }}>
                <CarpartsCreditCardOrderDetailsBadge />
              </div>
              <OrderInformationBox>
                <InformationBox>
                  <InformationTitleBox>
                    <Text color="dark-2" size="16px" weight={400}>
                      Order Date:&nbsp;
                    </Text>
                    <Text color="dark-2" size="16px" weight={600}>
                      {orderDetails.orderDate}
                    </Text>
                  </InformationTitleBox>
                  <OrderDetailsDivider />
                  <InformationTitleBox>
                    <Text color="dark-2" size="16px" weight={400}>
                      Order Status:&nbsp;
                    </Text>
                    <Text color="dark-2" size="16px" weight={600}>
                      {isMembershipOrder ? 'Enrolled' : orderDetails.orderStatus}
                    </Text>
                  </InformationTitleBox>
                  <OrderDetailsDivider />
                  <InformationTitleBox>
                    <Text color="dark-2" size="16px" weight={400}>
                      Order #:&nbsp;
                    </Text>
                    <Text color="dark-2" size="16px" weight={600} data-testid="order-details-order-merchantid">
                      {orderDetails.merchantOrderId}
                    </Text>
                  </InformationTitleBox>
                </InformationBox>
                <Border />
                <Box
                  width="100%"
                >
                {isSparkChatEnabled ?
                  <Text size="xsmall" color="border-2" weight={400}>
                    If you have any questions or concerns, you can{' '}
                    <LiveChat
                      onClick={OpenChatHandler}
                      href="#"
                      rel="noreferrer"
                    >
                      Chat With Spark
                    </LiveChat>
                    {' '}to get order related information and more.
                  </Text> :
                  <Text size="xsmall" color="border-2" weight={400}>
                    {'If you have any questions or concerns, you can contact us through our '}
                    <LiveChat
                      onClick={OpenChatHandler}
                      href="#"
                      rel="noreferrer"
                    >
                      Live Chat
                    </LiveChat>
                    . Our chat agents are available Mon-Sun from 4 AM to 8 PM PST.
                  </Text>
                }
                </Box>
                <Box direction={isDesktop ? 'row' : 'column'} gap='16px' style={{ marginTop: '16px' }}>
                  {!isMembershipOrder && <TrackOrderButton onClick={handleTrackPackageBtnClick} />}
                  <DownloadInvoiceButton onClick={onInvoicePrint} loading={invoiceLoading} buttonStyle={{ width: isDesktop ? '241px' : '100%' }} />
                </Box>
              </OrderInformationBox>

              <OrdersContainer>
                <OrdersWMO
                  isDesktop={isDesktop}
                  config={config}
                  orderDetails={orderDetails}
                  setDisplayReturnDetails={setDisplayReturnDetails}
                  setReturnDetailsData={setReturnDetailsData}
                  creditStatus={creditStatus}
                  returnRequestStatus={returnRequestStatus}
                  items={items}
                  orderStatus={orderDetails.orderStatus}
                  navigateToRMA={navigateToRMA}
                  orderId={orderDetails.orderId}
                  formatBrand={formatBrand}
                  OpenChatHandler={OpenChatHandler}
                  coreConfig={coreConfig}
                  history={history}
                  isESPP={isESPP}
                  eSPPAmount={eSPPAmount}
                  GTM={GTM}
                  productProtectionPlan={productProtectionPlan}
                  isEppSubtext={isEppSubtext}
                  unfoldedShippingConfig={unfoldedShippingConfig}
                />
              </OrdersContainer>
              { !isMobile && <UptickWrapper id="uptick-offers" data-uptick-target="content" class="uptick-target section" data-test-id="uptick-container" isMobile={isMobile}/> }
            </OrderDetailsContainer>
            <OrderSummaryContainer data-testid="order-details-order-summary">
              <Box>
                <Text size='20px' color='dark-2' weight='500'>Order Summary <Text size='20px' color='dark-5' weight='400'>{`(${orderDetails.items.length} Items)`}</Text></Text>
                <Divider />
                <ToolTipContainer>
                  {showToolTip && (
                    <ToolTip id="tooltiptext">
                      <ToolTipContent
                        dangerouslySetInnerHTML={{
                          __html: `<b>Subtotal</b> is the sum of all item totals. 
                          Each item total is comprised of <b>Unit Price</b>, 
                          <b>Protection Plan</b>, and <b>Core Charge</b> (where applicable), 
                          multiplied by <b>Quantity</b>.`,
                        }}
                      />
                      <ToolTipArrow>
                        <IcoMoon icon={ArrowDownIcon} color="white" size="40px" />
                      </ToolTipArrow>
                    </ToolTip>
                  )}
                  <Text size="16px" color="dark-2">
                    Subtotal
                  </Text>
                  <SubTotalTipIcon
                    id="subtotaltooltipicon"
                  >
                    <IcoMoon
                      icon={QuestionIcon}
                      size="18px"
                      color="#b2b2b2"
                      onClick={onToolTip}
                    />
                  </SubTotalTipIcon>
                  <Text size="16px" color="dark-2">
                    {`$${commaSeparetedValue(orderSummary.subtotal)}`}
                  </Text>
                </ToolTipContainer>
                {eSPPAmount > 0 && (
                  <OrderSummaryRow direction="row" justify="between">
                    <Text size="16px" color="dark-2">
                      Shipping Protection:
                    </Text>
                    <Text size="16px" color="dark-2">
                      {`$${commaSeparetedValue(eSPPAmount)}`}
                    </Text>
                  </OrderSummaryRow>
                )}
                {orderSummary?.totalProductProtection > 0 && (
                  <OrderSummaryRow direction="row" justify="between">
                    <Text size="16px" color="dark-2">
                      Product Protection:
                    </Text>
                    <Text size="16px" color="dark-2">
                      {`$${commaSeparetedValue(orderSummary?.totalProductProtection)}`}
                    </Text>
                  </OrderSummaryRow>
                )}
                {orderSummary.totalWarranty > 0 && orderSummary?.totalProductProtection <= 0 && (
                  <OrderSummaryRow direction="row" justify="between">
                    <Text size="16px" color="dark-2">
                      Part Protection:
                    </Text>
                    <Text size="16px" color="dark-2">
                      {`$${commaSeparetedValue(orderSummary.totalWarranty)}`}
                    </Text>
                  </OrderSummaryRow>
                )}
                {orderSummary?.totalCorePrice > 0 && (
                  <OrderSummaryRow direction="row" justify="between">
                    <Text size="16px" color="dark-2">
                      Core Charge:
                    </Text>
                    <Text size="16px" color="dark-2">
                      {`$${commaSeparetedValue(orderSummary.totalCorePrice)}`}
                    </Text>
                  </OrderSummaryRow>
                )}
                <OrderSummaryRow direction="row" justify="between">
                  <Text size="16px" color="dark-2">
                    Shipping:
                  </Text>
                  <Text size="16px" color="dark-2">
                    {`$${commaSeparetedValue(orderSummary.totalShipping)}`}
                  </Text>
                </OrderSummaryRow>
                <OrderSummaryRow direction="row" justify="between">
                  <Text size="16px" color="dark-2">
                    Handling:
                  </Text>
                  <Text size="16px" color="dark-2">
                    {`$${commaSeparetedValue(orderSummary.totalHandling)}`}
                  </Text>
                </OrderSummaryRow>
                <OrderSummaryRow direction="row" justify="between">
                  <Text size="16px" color="dark-2">
                    Tax:
                  </Text>
                  <Text size="16px" color="dark-2">
                    {`$${commaSeparetedValue(orderSummary.totalTax)}`}
                  </Text>
                </OrderSummaryRow>
                {
                  orderSummary.totalDiscount &&
                    (orderSummary.totalDiscount !== '0.00' &&
                      orderSummary.totalDiscount !== '0') ?
                    <OrderSummaryRow direction="row" justify="between">
                      <Text size="16px" color="dark-2">
                        Coupon:
                      </Text>
                      <Text size="16px" color="dark-2">
                        {`- $${commaSeparetedValue(orderSummary.totalDiscount)}`}
                      </Text>
                    </OrderSummaryRow>
                    :
                    null
                }
                <OrderSummaryRow direction="row" justify="between">
                  <Text size="16px" color="dark-2" weight={500}>
                    Order Total:
                  </Text>
                  <Text size="16px" color="dark-2" weight={500}>
                    {`$${commaSeparetedValue(orderSummary.total)}`}
                  </Text>
                </OrderSummaryRow>
              </Box>
              <Box>
                <Text size='20px' color='dark-2' weight='500'>Shipping Information</Text>
                <Divider />
                <Text color="dark-2" size="16px" weight={400} style={{ marginBottom: '12px' }}>
                  {shipping.name}
                </Text>
                <Box style={{ gap: '4px' }}>
                  <Text color="dark-2" size="16px" weight={400}>
                    {shipAddress.streetAddress}
                  </Text>
                  {shipAddress.suburbAddress && (
                    <Text color="dark-2" size="16px" weight={400}>
                      {shipAddress.suburbAddress}
                    </Text>
                  )}
                  <Text color="dark-2" size="16px" weight={400}>
                    {`${shipAddress.city} ${shipAddress.state
                      }, ${shipAddress.postcode}`}
                  </Text>
                  <Text color="dark-2" size="16px" weight={400}>
                    {shipAddress.country}
                  </Text>
                </Box>

                <Text color="dark-2" size="16px" weight={400} style={{ margin: '12px 0' }}>
                  {beautifyTelephoneNumber(shipping.telephone)}
                </Text>

              </Box>
              <Box>
                <Text size='20px' color='dark-2' weight='500'>Payment Information</Text>
                <Divider />
                <Box style={{ gap: '4px', marginBottom: '20px' }}>
                  <Text color="dark-2" size="16px" weight={500}>
                    Payment Method
                  </Text>
                  <Text color="dark-2" size="16px" weight={400}>
                    {billing.paymentMethod}
                  </Text>
                </Box>
                <Box style={{ gap: '4px' }}>
                  <Text color="dark-2" size="16px" weight={500}>
                    Billing Address
                  </Text>
                  <Text color="dark-2" size="16px" weight={400}>
                    {billing.address.streetAddress}
                  </Text>
                  {billing.address.suburbAddress ?
                    <Text color="dark-2" size="16px" weight={400}>
                      {billing.address.suburbAddress}
                    </Text> : null}
                  <Text color="dark-2" size="16px" weight={400}>
                    {`${billing.address.city} ${billing.address.state}, ${billing.address.postcode
                      }`}
                  </Text>
                  <Text color="dark-2" size="16px" weight={400}>
                    {`Phone number: ${beautifyTelephoneNumber(billing.telephone)}`}
                  </Text>
                </Box>
              </Box>
            </OrderSummaryContainer>
            { isMobile && <UptickWrapper id="uptick-offers" data-uptick-target="content" class="uptick-target section" data-test-id="uptick-container" isMobile={isMobile}/> }
          </Container>
          <EnablePushNotificationModal content={pushNotificationData} />
        </MainContainer>
      </BackgroundColorWrapper>
      {isTrackOrder ? <OrderDetailRecomWrapper>{recommendationsComponent}</OrderDetailRecomWrapper> : null}
    </div>

  )
}